import type { HydrationOptions } from 'react-dom/client';
import { fg } from '@atlassian/jira-feature-gating';
import log from '@atlassian/jira-common-util-logging/src/log.tsx';
import { captureException as reportToSentry } from '@atlassian/jira-capture-exception/src/index.tsx';

const location = 'react-hydrate-root';

export const hydrationOptions: HydrationOptions = {
	onRecoverableError: (untypedError, errorInfo) => {
		if (!fg('jfp-magma-log-hydration-errors')) {
			return;
		}

		const error: Error =
			untypedError instanceof Error
				? untypedError
				: new Error(`Unknown error occurred during hydration: ${JSON.stringify(untypedError)}`);

		log.safeErrorWithoutCustomerData(location, 'onRecoverableError', error);
		reportToSentry(location, error, { ...errorInfo });
	},
};
